const css = `.sidebar-button.p-button.p-button-link {
  position: relative;
  align-items: anchor-center;
  padding: var(--space-3) var(--space-4);
  width: 100%;
  height: 40px;
  text-align: left;
  font-size: var(--font-size-sm);
  color: var(--text-muted);
  transition: background-color 0.2s, box-shadow 0.2s, padding 0.5s ease;
}
.sidebar-button.p-button.p-button-link:focus, .sidebar-button.p-button.p-button-link:active {
  outline: 0 none;
  outline-offset: 0;
  transition: box-shadow 0.2s;
  box-shadow: inset var(--focus-ring) !important;
}
.sidebar-button.p-button.p-button-link .p-button-label {
  font-size: var(--font-size-sm);
  transition: none;
  font-weight: var(--font-weight-regular);
  text-decoration: none;
  white-space: nowrap;
}
.sidebar-button.p-button.p-button-link .p-button-icon {
  font-size: var(--font-size-sm);
  margin-right: auto;
}
.sidebar-button.p-button.p-button-link:hover {
  background-color: var(--surface-hover);
}
.sidebar-button.p-button.p-button-link.selected {
  color: var(--accent);
}
.sidebar-button.p-button.p-button-link.selected span {
  font-weight: var(--font-weight-bold);
}
.sidebar-button.p-button.p-button-link .p-badge {
  position: absolute;
  right: 0;
  top: 0;
  background-color: var(--accent);
  color: var(--accent-text);
  padding: 0 var(--space-1);
  font-size: var(--font-size-xs);
  transition: transform 0.5s ease, top 0.5s ease, right 0.5s ease;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
